import instance from "../axios";

export const getAll = async (filters = {}) => {
  const response = await instance.get("stocks", { params: filters });
  return response.data;
};

export const getDetails = async (id) => {
  const response = await instance.get(`stocks/${id}`);
  return response.data;
};

export const insert = async (data) => {
  const response = await instance.post("stocks", data);
  return response;
};

export const update = async (data) => {
  const response = await instance.put("stocks", data);
  return response;
};

export const remove = async (id) => {
  const response = await instance.delete(`stocks/${id}`);
  return response;
};

